import React from 'react'
import {useTranslation} from '@lib/intl/useTranslations'
import {apiUploadImage} from '@api/core/image/uploadImage'
import {apiEditThumbnail} from '@api/user/account/editThumbnail'
import useSnackbar from '@hook/useSnackbar'
import useQueryFetchMe from '@hook/query/account/useQueryFetchMe'

const UserAccountThumbnailChangeInput = () => {
    const t = useTranslation()
    const {showSnackbar, showErrorSnackbar} = useSnackbar()

    const {refetch} = useQueryFetchMe(undefined, false)

    const changeImage = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e?.target?.files[0]

        if (file) {
            const result = await apiUploadImage(file)
            if (result.success) {
                const {data, error} = await apiEditThumbnail(result.image_url)
                if (data) {
                    showSnackbar(t('mobileAccountNavigation.thumbnail.changeImage.success'))
                    await refetch()
                    return
                } else {
                    showErrorSnackbar(error)
                }
            }
        }

        e.target.value = ''
        showSnackbar(t('mobileAccountNavigation.thumbnail.changeImage.fail'))
        return
    }

    return (
        <>
            <input id={'thumb-file-input'} type="file" style={{display: 'none'}} onChange={changeImage} />
        </>
    )
}
export default UserAccountThumbnailChangeInput
